module.exports = __webpack_public_path__ + "static/media/loanHistoryIcon.6941b00b.svg";